import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CartService } from '../cart.service';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'tea-shop-fe-checkout',
    templateUrl: './checkout.component.html',
    styleUrl: './checkout.component.css',
    imports: [NgTemplateOutlet]
})
export class CheckoutComponent implements OnInit, OnDestroy {
  private cartService = inject(CartService);
  private metaDataService = inject(MetaDataService);
  private logger = inject(NGXLogger);

  sessionId: string | null = null;
  errors: string[] = [];
  isLoading = true;

  checkout: any = null;

  constructor() { 
    this.metaDataService.updateMetadata({
      title: 'Checkout',
      image: '/assets/contact/sencha-logo.png',
    });
  }

  ngOnDestroy() {
    if (this.checkout) {
      this.logger.info('Unmounting checkout');
      this.checkout.destroy();
    }
  }

  ngOnInit() {
    this.cartService.createCheckoutSession().subscribe({
      next: async (session) => {
        this.logger.info(`Checkout init`, session);
        this.sessionId = session.sessionId;
        this.isLoading = false;
        try {
          this.checkout = await this.cartService.initialiseEmbeddedCheckout(this.sessionId);
          this.checkout.mount('#checkout')
        } catch (error: any) {
          this.logger.error('An error occurred while initialising the embedded checkout:', error);
          this.errors.push(error.message);
        }
      },
      error: (error) => {
        this.logger.error('An error occurred while creating a checkout session:', error);
        this.errors.push('An error occurred while creating a checkout session. Please try again shortly.');
        this.isLoading = false;
      }
    });
  }
}
